import script from "./AdminView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminView.vue?vue&type=script&setup=true&lang=js"

import "./AdminView.vue?vue&type=style&index=0&id=e37c275c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e37c275c"]])

export default __exports__